define('models/merchants/giftcard',['backbone'], function (Backbone) {
    var GiftCard = Backbone.Model.extend({
        
        url: function(){  
            if(this.MerchantGUID == undefined || this.MerchantGUID == null){
                return pf.consumerURL + "/ecards";
            } else {
                return pf.consumerURL + "/ecards?MerchantGUID=" + this.MerchantGUID;
            }
        },

        initialize: function(options){
            options || (options = {});
            this.GiftCardGUID = options.GCGID;
            //this.UserID = options.UID;
            this.MerchantGUID = options.MGUID;
            this.MerchantGroupGUID = options.MGGUID;
            this.VendorGiftCardID = options.VGCID;  
            this.Balance = options.B;
            this.BalanceDate = options.BD;
            this.PurchaseAmount = options.PA;
            //this.ActivationSpotURL = options.ASURL;
            this.BlackhawkMerchantGroupConfigurationID = options.BMGCID;
            this.GiftCardStatus = options.GCS;
            this.GiftCardStatusID = options.GCSID;
            this.CreatedDate = options.CD;
            this.GiftCardImagelarge = options.GCIL;
            this.GiftCardImageXlarge = options.GCIXL;
            this.GroupName = options.GN;
            this.GroupLogo = (options.MGL != null && options.MGGUID != null) ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, options.MGGUID, pf.enums.imageTypeGUIDEnum.Profile, options.MGL) : null;
            this.BlackhawkTenantID = options.BTI;
        },

        parse: function(data){
            var response = {};
            
            response.GiftCardGUID = data.GCGID;
            response.MerchantGUID = data.MGUID;
            response.MerchantGroupGUID = data.MGGUID;
            response.VendorGiftCardID = data.VGCID;
            response.Balance = data.B;
            response.BalanceInquiryStatus = data.BIS;
            response.PurchaseAmount = data.PA;
            response.BalanceDate = data.BD;
            //response.ActivationSpotURL = data.ASURL;
            response.BlackhawkMerchantGroupConfigurationID = data.BMGCID;
            response.GiftCardStatus = data.GCS;
            response.GiftCardStatusID = data.GCSID;
            response.CreatedDate = data.CD;
            response.GiftCardImagelarge = data.GCIL;
            response.GiftCardImageXlarge = data.GCIXL;
            response.GroupName = data.GN;
            response.GroupLogo = (data.MGL != null && data.MGGUID != null) ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, data.MGGUID, pf.enums.imageTypeGUIDEnum.Profile, data.MGL) : null;
            response.BlackhawkTenantID = data.BTI;
            
            return response;
        },

        group: function(a,b,c,d){
            console.log('Group data',a,b,c,d);
        }
       
    });

    return GiftCard;
});

